module.exports = __webpack_public_path__ + "static/Dillons_pin-df7f4d1f1c88301ceb35646ee5463b8d.png";